import { useIsFocused } from '@react-navigation/native';
import { useNavigation } from 'expo-router';

/**
 * A safer alternative to `useIsFocused` from `@react-navigation/native`
 * that works in both react-navigation and expo-router contexts.
 *
 * When rendered inside a `NavigationContainer`, behaves identically to
 * `useIsFocused` — returns a stateful boolean that updates on focus/blur.
 *
 * When rendered outside a `NavigationContainer` (e.g. `expo-router` screens),
 * falls back to `useNavigation().isFocused()` from `expo-router`.
 */
export const useSafeIsFocused = (): boolean => {
  try {
    return useIsFocused();
  } catch {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useNavigation().isFocused();
  }
};
